// extracted by css-extract-rspack-plugin
export default {"footerContent":"SignedCommitFooter-module__footerContent__wvcZE","Link":"SignedCommitFooter-module__Link__FPvy7","Link_1":"SignedCommitFooter-module__Link_1__BwwyB"};